export default __webpack_public_path__ + "static/media/bgDeskGreen.8fe97335.svg";